import React, { useContext } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';

function DeleteTotalExpensesCategory({id, setTotalExpense}) {

    const appState = useContext(StateContext)

    async function deleteHandler(e) {
        e.preventDefault();
        try {
            const totalExpenseRef = firestore.collection("users").doc(appState.userId).collection("total-budget-categories").doc(id);
            totalExpenseRef.delete();
            setTotalExpense(null)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <i className="fas fa-trash text-danger" onClick={deleteHandler}></i>
    )
}
export default DeleteTotalExpensesCategory